import SignupValidationAPI from '../APIs/SignupAPI/SignupValidationAPI'
// import ClientPortal from '../../plugins/axios'

export const getCsrfToken = {
    state: {},
    actions: {
        async getCsrfToken() {
            await SignupValidationAPI.getCsrfToken()
            // ClientPortal.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken
            // // console.log('csrf token in vue: ', res.data.csrfToken);
            // return ClientPortal.defaults.headers

            // axios.create({withCredentials: true}).get('http://localhost:3000/api/getcsrftoken').then((response) => {
            //   axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken
            //   console.log('token in vue: ', response.data.csrfToken);
            // }, (err) => {
            //   console.log(err);
            // });
            // console.log("DUMAAN SA CSRFTOKEN MODULE SIGNUP");
        }
    },
    mutations: {},
    getters: {}
}
